import styled, { keyframes } from 'styled-components';
import { TypographyStyles, accordionAnimation, accordionArrowAnimation, colours, spacing } from '../../../stylings';

const footerAccordionOpen = keyframes`
    from {
       margin-bottom: unset;
       max-height: 0;
    }

    to {
      margin-bottom: ${spacing.XXS};
      max-height: 2000px;
    }
`;

const footerAccordionClose = keyframes`
    from {
       margin-bottom: ${spacing.XXS};
       max-height: 2000px;
    }

    to {
       margin-bottom: unset;
       max-height: 0;
    }
`;

export const MobileAccordionHeader = styled.button<{ $isAccordionOpen: boolean }>`
  align-items: center;
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  padding: 23px ${spacing.XXXS} 23px 0;
  width: 100%;
  ${({ $isAccordionOpen }) => accordionArrowAnimation($isAccordionOpen)}
  svg {
    display: inline-block;
    height: 5.73px;
    width: 9.75px;
  }
`;

export const MobileAccordionHeaderText = styled.h3`
  ${TypographyStyles.Body.Small.SemiBold}
  color: ${colours.BLACK};
  overflow-wrap: anywhere;
`;

export const MobileAccordionLinks = styled.ul<{ $isAccordionOpen: boolean }>`
  display: ${({ $isAccordionOpen }) => ($isAccordionOpen ? 'flex' : 'none')};
  flex-direction: column;
  gap: ${spacing.XXXS};
  ${({ $isAccordionOpen }) => accordionAnimation($isAccordionOpen, footerAccordionOpen, footerAccordionClose)}
  margin: 0;
  overflow: hidden;
  padding: 0;

  @media (prefers-reduced-motion) {
    margin-bottom: ${({ $isAccordionOpen }) => ($isAccordionOpen ? `${spacing.XXS}` : 'unset')};
  }
`;

export const MobileAccordionCommonLinkItem = styled.li`
  ${TypographyStyles.Body.Small.Regular}
  overflow-wrap: anywhere;

  a {
    color: ${colours.BLACK};
    padding: 3px 0;
    text-decoration: none;
  }
`;
